import { useEffect, useMemo } from 'react'
import { createLogger } from '@/lib/logger'

/**
 * React hook for component-specific logging
 * @param componentName - Name of the component using the logger
 * @returns Logger instance for the component
 */
export function useLogger(componentName: string) {
  const logger = useMemo(() => createLogger(componentName), [componentName])

  useEffect(() => {
    logger.debug(`Component mounted: ${componentName}`)
    
    return () => {
      logger.debug(`Component unmounted: ${componentName}`)
    }
  }, [logger, componentName])

  return logger
}

export default useLogger